import { z } from "zod";
import { automationIdSchema } from "../entities/automation.js";
import { playbookIdSchema } from "../entities/playbook.js";
import { signalIdSchema } from "../entities/signal.js";
import { teammateIdSchema } from "../entities/teammate.js";
import { topicIdSchema } from "../entities/topic.js";
const pageContextDescriptorSchema = z.discriminatedUnion("page", [
  z.object({
    page: z.literal("teammate"),
    playbookId: playbookIdSchema,
    teammateId: teammateIdSchema
  }),
  z.object({
    page: z.literal("playbook"),
    playbookId: playbookIdSchema
  }),
  z.object({
    page: z.literal("playbookConfiguration"),
    playbookId: playbookIdSchema
  }),
  z.object({
    page: z.literal("teammateAgent"),
    /** Voice agents are teammates of type AGENT. */
    teammateAgentId: teammateIdSchema
  }),
  z.object({
    page: z.literal("signalConfiguration"),
    /** Absent while the user is creating a signal that is not saved yet. */
    signalId: signalIdSchema.optional()
  }),
  z.object({
    page: z.literal("automationConfiguration"),
    /** Absent while the user is creating an automation that is not saved yet. */
    automationId: automationIdSchema.optional()
  }),
  z.object({
    // Named for the project, not the training: one configuration route serves
    // recruiting and training projects alike, and the descriptor is built from
    // the URL, which does not say which kind this is. Hydration resolves the
    // project and grounds each kind on its own terms.
    page: z.literal("projectConfiguration"),
    /** The project whose configuration tab is open — training or recruiting. */
    projectId: z.uuid()
  }),
  z.object({
    page: z.literal("knowledgeBaseDocument"),
    knowledgeBaseId: z.uuid(),
    /** The document open in the editor. Ids are not branded for attachments. */
    attachmentId: z.uuid()
  }),
  z.object({
    page: z.literal("topics"),
    playbookId: playbookIdSchema,
    /** Set only when the user has drilled into one topic's page. */
    topicId: topicIdSchema.optional()
  })
]);
function resolvePageContextGrounding(pageContext, legacyThreadScope) {
  if (pageContext) {
    return pageContext;
  }
  const { teammateAgentId, playbookId } = legacyThreadScope;
  if (teammateAgentId) {
    return { page: "teammateAgent", teammateAgentId };
  }
  if (playbookId) {
    return { page: "playbook", playbookId };
  }
  return void 0;
}
export {
  pageContextDescriptorSchema,
  resolvePageContextGrounding
};
//# sourceMappingURL=pageContext.js.map
